import React from 'react';

export default function H1_ST({data}) {

  return (
      <h1>{data?.Titre}</h1>
  );
}
